export const ls = {
  signIn: "RECUPERAR CONTRASEÑA",
  secondaryText: "Ingrese su correo electronico o nombre de usuario:",
  placeholderUser: "Nombre de usuario o correo electrónico",
  btnText: "Recuperar contraseña",
  forgot: "Regresar a iniciar sesión",
  footerSecondText: "Aviso de Privacidad",
  footerThirdText: "Contacto",
};
